import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
} from "@mui/material";

import endpoints from "../../endpoint";
import { getImageUrl } from "../../utils/helpFunction";

const PartnerLeads = () => {
  const [leads, setLeads] = useState([]);
  const [filteredLeads, setFilteredLeads] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchPartnerDeals = async () => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    try {
      const response = await axios.get(
        `${endpoints.serverBaseUrl}api/partner/partner-leads/${user.userId}`,
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      // Set state with fetched leads
      setLeads(response.data.leads);
      setFilteredLeads(response.data.leads);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching partner leads:", error);
      setError("Failed to fetch leads.");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPartnerDeals();
  }, []);

  // Handle Search Filtering
  useEffect(() => {
    const filtered = leads.filter(
      (lead) =>
        lead.name.toLowerCase().includes(search.toLowerCase()) ||
        lead.email.toLowerCase().includes(search.toLowerCase()) ||
        lead.mobile.includes(search)
    );
    setFilteredLeads(filtered);
  }, [search, leads]);

  return (
    <Grid container>
      <Grid item xs={12} md={12} lg={12} mt={2} sx={{ borderRadius: 2 }}>
        <TextField
          fullWidth
          variant="outlined"
          label="Search by Name, Email, or Mobile"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ mb: 2 }}
        />

        {loading ? (
          <Grid container justifyContent="center" sx={{ py: 4 }}>
            <CircularProgress />
          </Grid>
        ) : error ? (
          <Typography color="error" align="center">
            {error}
          </Typography>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead sx={{ bgcolor: "#1976D2" }}>
                <TableRow>
                  <TableCell sx={{ color: "#fff" }}>Name</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Email</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Mobile</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Category</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Amount</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Status</TableCell>
                  <TableCell sx={{ color: "#fff" }}>Payment Proof</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredLeads.length > 0 ? (
                  filteredLeads.map((lead) => (
                    <TableRow key={lead._id} hover>
                      <TableCell>{lead.name}</TableCell>
                      <TableCell>{lead.email}</TableCell>
                      <TableCell>{lead.mobile}</TableCell>
                      <TableCell>{lead.category}</TableCell>
                      <TableCell>₹{lead.amountReceived}</TableCell>
                      <TableCell>{lead.status}</TableCell>
                      <TableCell>
                        {lead.paymentProof ? (
                          <a
                            href={getImageUrl(lead.publicId)}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={getImageUrl(lead.publicId)}
                              alt="Payment Proof"
                              style={{
                                width: "50px",
                                height: "50px",
                                objectFit: "cover",
                                borderRadius: "5px",
                              }}
                            />
                          </a>
                        ) : (
                          "No Image"
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No leads found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Grid>
    </Grid>
  );
};

export default PartnerLeads;
